import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_coffee_tea_lovers: FaireThemeEntity = {
  token: "discovery_theme_coffee-tea-lovers",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Coffee & Tea Lovers",
  description: "Curated picks for caffeine enthusiasts",
  bgColor: "#E0D4C8",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
